import _ from 'lodash';

import * as Dashboard from 'types';
import AppConstants from 'constants/AppConstants';

interface State {
  visibility: Dashboard.SectionVisibility;
}

export const initialState: State = {
  visibility: {},
};

function convertToObject(
  labels: string[],
  updater: (label: string) => boolean
): Dashboard.SectionVisibility {
  const result: Dashboard.SectionVisibility = {};
  _.forEach(labels, (label) => {
    result[label] = updater(label);
  });
  return result;
}

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.TEMPLATE_SECTIONS_OPEN_SECTION: {
      return {
        ...state,
        visibility: {
          ...state.visibility,
          ...convertToObject(payload, () => true),
        },
      };
    }
    case AppConstants.TEMPLATE_SECTIONS_CLOSE_SECTION: {
      return {
        ...state,
        visibility: {
          ...state.visibility,
          ...convertToObject(payload, () => false),
        },
      };
    }
    case AppConstants.TEMPLATE_SECTIONS_TOGGLE_SECTION: {
      return {
        ...state,
        visibility: {
          ...state.visibility,
          ...convertToObject(payload, (label) => !state.visibility[payload]),
        },
      };
    }
    default:
      return state;
  }
}
